// extracted by mini-css-extract-plugin
export default {"root":"RepeatPurchaseMobileModal__root--2jT8s","text":"RepeatPurchaseMobileModal__text--2o3Q6","transparent":"RepeatPurchaseMobileModal__transparent--1v7u_"};